<template>
  <div class="custom-radio-container">
    <button
      tabindex="0"
      role="button"
      v-for="option in options"
      :key="option"
      class="custom-radio-button"
      :class="{ active: isActive(option) }"
      @click="updateState(option)"
    >
      <span v-html="formatText(option)"></span>
    </button>
  </div>
</template>

<script>
import { state } from '@/lib/state'

export default {
  props: {
    options: {
      type: Array,
      required: true,
    },
    stateKey: {
      type: String,
      required: true,
    },
  },
  mounted() {
    console.log('mounted')
    console.log(
      'state.answers[this.stateKey]  if empty we are entering the question and can freely override with member data =========> ',
      state.answers[this.stateKey],
    )
    if (state.user?.memberData[this.stateKey] && !state.answers[this.stateKey]) {
      console.log('member has data for this field ')
      console.log('DATA ==> ', state.user?.memberData[this.stateKey])

      // set value from member data if it exists and state is empty
      const memberDataValue = state.user?.memberData[this.stateKey]
      // Find the option that matches the member data value
      const selectedOption = this.options.find(
        (option) => option.id === memberDataValue || option.workareaid === memberDataValue,
      )
      if (selectedOption) {
        this.updateState(selectedOption)
      }
    }
  },
  methods: {
    updateState(option) {
      const selectedOption = option
      const value = selectedOption.id || selectedOption.workareaid
      state.answers[this.stateKey] = value
      state.displayAnswers[this.stateKey] = selectedOption.text || selectedOption.workareatext

      // Emit validation events based on the selected value
      if (value) {
        this.emitter.emit(`validate-${this.stateKey}`)
      } else {
        this.emitter.emit(`invalidate-${this.stateKey}`)
      }
    },
    formatText(option) {
      const text = option?.text || option?.workareatext || ''
      // Split the text by '/' and wrap each segment in a span for breaking
      return text
        .split('/')
        .map((part) => `<span>${part}</span>`)
        .join('/<wbr>') // Insert a word break opportunity after each '/'
    },
    isActive(option) {
      const id = option.id || option.workareaid
      return state.answers[this.stateKey] === id
    },
  },
}
</script>

<style lang="postcss" scoped>
.custom-radio-container {
  display: flex;
  gap: 16px;
  flex-direction: column;
}

.custom-radio-button {
  padding: 10px 20px;
  background-color: var(--color-white);
  border-radius: 999px;
  cursor: pointer;
  text-align: center;
  color: #005BF5;
  font-weight: 500;
  font-family: var(--font-it-ex);
  font-size: var(--font-size-body);
  line-height: 24px;
}

.custom-radio-button span {
  white-space: wrap;
}

.custom-radio-button wbr {
  display: inline; /* Ensure word break opportunities are available */
}

.custom-radio-button:focus-visible {
  outline: none;
  box-shadow: inset 0 0 0 2px var(--color-darkblue);
}

.custom-radio-button.active {
  background-color: var(--color-darkblue);
  color: white;
}

@media (min-width: 1024px) {
  .custom-radio-container {
    flex-direction: row;
    column-gap: 36px;
    row-gap: 18px;
    flex-wrap: wrap;
    align-items: stretch; /* Ensure all items stretch to the height of the tallest item */
  }
  .custom-radio-button {
    width: 242px;
    min-height: 50px;
    border-radius: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    align-self: stretch; /* Stretch the item to the height of the container */
    line-height: 15px;
    font-size: 14px;
  }
}
</style>
